import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","display":"flex"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Assets Summary", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Update Asset Metrics")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Schwab Employee assets ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_switch = _resolveComponent("o-switch")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_o_button, {
        onClick: $setup.update52WeekHighs,
        style: {"margin-left":"auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_fa_icon, {
            icon: "sync",
            style: {"margin-right":"8px"},
            spin: $setup.loading
          }, null, 8, ["spin"]),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_o_field, null, {
        default: _withCtx(() => [
          _createVNode(_component_o_switch, {
            modelValue: $setup.showSchwabEmployeeAssets,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.showSchwabEmployeeAssets) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_ag_grid_vue, {
        class: "ag-theme-alpine",
        rowData: $setup.assetListFiltered,
        domLayout: "500",
        style: {"height":"55rem"},
        defaultColDef: $setup.defaultColDef,
        columnDefs: $setup.columnDefs.value,
        onGridReady: $setup.onGridReady
      }, null, 8, ["rowData", "defaultColDef", "columnDefs", "onGridReady"])
    ])
  ]))
}